import { createFileRoute, redirect } from "@tanstack/react-router";
import { workspaceSearchSchema } from "@/features/provider-workspace/workspace-search";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/workspace/",
)({
  validateSearch: workspaceSearchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/credentials",
      params,
      search,
      replace: true,
    });
  },
});
